export default function SvgValidate4() {
  return (
    <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      fill="none"
      viewBox="0 0 24 24"
      >
      <path
      stroke="#00cc00"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M20 7L9 18l-5-5"
    ></path>
  </svg>
  </>
);
}
